import { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendEmail } from '../services/sendEmail';
import './Contato.css';

function Contato() {
  const [form, setForm] = useState({ nome: '', empresa: '', email: '', mensagem: '' });
  const [status, setStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setErrorMessage('');

    try {
      await sendEmail({
        subject: `Contato - SingleSystem - ${form.empresa || form.nome}`,
        replyTo: form.email,
        fields: {
          nome: form.nome,
          empresa: form.empresa || 'Não informado',
          email: form.email,
          mensagem: form.mensagem,
        },
      });
      setStatus('success');
      setForm({ nome: '', empresa: '', email: '', mensagem: '' });
    } catch (err) {
      setStatus('error');
      setErrorMessage(err.message || 'Erro ao enviar. Tente novamente.');
    }
  };

  return (
    <div className="contato-page">
      <div className="page-hero">
        <h1>Contato</h1>
        <p>Vamos conversar sobre o seu projeto. Sem compromisso.</p>
      </div>

      <section className="section">
        <div className="container contato-grid">
          <div className="contato-info">
            <h2>Vamos conversar?</h2>
            <p>
              Você explica seu processo.<br />
              Nós mostramos uma solução.<br />
              <strong>Sem compromisso.</strong>
            </p>

            <div className="contato-links">             
              <a href="mailto:fernandomacedoborelli@gmail.com">E-mail</a>
              <a href="https://www.linkedin.com/in/fernandomacedoborelli" target="_blank" rel="noopener noreferrer">
                LinkedIn
              </a>
            </div>

            <Link to="/diagnostico" className="btn btn-primary btn-large">
              Agendar diagnóstico
            </Link>
          </div>

          {status === 'success' ? (
            <div className="contato-success">
              <h2>Mensagem enviada!</h2>
              <p>Recebemos seu contato. Em breve retornaremos.</p>
              <button type="button" className="btn btn-outline" onClick={() => setStatus('idle')}>
                Enviar outra mensagem
              </button>
            </div>
          ) : (
            <form className="contato-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="nome">Nome</label>
                <input type="text" id="nome" name="nome" value={form.nome} onChange={handleChange} required placeholder="Seu nome" disabled={status === 'sending'} />
              </div>
              <div className="form-group">
                <label htmlFor="empresa">Empresa</label>
                <input type="text" id="empresa" name="empresa" value={form.empresa} onChange={handleChange} placeholder="Nome da empresa" disabled={status === 'sending'} />
              </div>
              <div className="form-group">
                <label htmlFor="email">E-mail</label>
                <input type="email" id="email" name="email" value={form.email} onChange={handleChange} required placeholder="seu@email.com" disabled={status === 'sending'} />
              </div>
              <div className="form-group">
                <label htmlFor="mensagem">Descreva o processo</label>
                <textarea id="mensagem" name="mensagem" value={form.mensagem} onChange={handleChange} required rows={5} placeholder="Conte como funciona o processo na sua empresa..." disabled={status === 'sending'} />
              </div>

              {status === 'error' && (
                <p className="form-error" role="alert">{errorMessage}</p>
              )}

              <button type="submit" className="btn btn-primary btn-large" disabled={status === 'sending'}>
                {status === 'sending' ? 'Enviando...' : 'Enviar mensagem'}
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}

export default Contato;
